export default __webpack_public_path__ + "static/media/boostSpeed.2c1e72fe.png";